var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.25c-3 0-5 2.25-5 5.5 0 5.155 4.203 8.319 7.018 9.86.972.532 1.459.799 2.482.799 1.023 0 1.51-.267 2.482-.8 2.815-1.54 7.018-4.704 7.018-9.859 0-3.25-2-5.5-5-5.5-1.993 0-3.235 1.035-3.896 1.835-.324.392-.486.588-.604.588s-.28-.196-.604-.588c-.662-.8-1.903-1.835-3.896-1.835Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike24);
export default __webpack_public_path__ + "static/media/like_24.5679bac8.svg";
export { ForwardRef as ReactComponent };